var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "svg-icon",
  style: {
    width: "1em",
    height: "1em",
    verticalAlign: "middle",
    fill: "currentColor",
    overflow: "hidden"
  },
  viewBox: "0 0 1024 1024"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M256 102.4v819.2L768 512 256 102.4z"
})));
export default SvgArrowRight;